import moment from 'moment';
import 'moment-timezone/builds/moment-timezone-with-data-1970-2030';

import momentLocalizer from 'react-widgets-moment';
import simpleNumberLocalizer from 'react-widgets-simple-number';

moment.locale('en');

momentLocalizer();
simpleNumberLocalizer();

// Expose variables that are required in the views
window.moment = moment;
